interface Props {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: { label: string; onClick: () => void };
  tone?: 'info' | 'warn';
}

export function EmptyState({ icon, title, description, action, tone = 'info' }: Props) {
  const bg = tone === 'warn' ? 'bg-amber-50 text-amber-900' : 'bg-slate-50 text-slate-700';
  return (
    <div
      className={`flex flex-col items-center gap-2 rounded p-3 text-center text-xs ${bg}`}
      role="status"
    >
      {icon && (
        <div aria-hidden="true" className="text-2xl">
          {icon}
        </div>
      )}
      <div className="font-semibold">{title}</div>
      {description && <div className="leading-snug opacity-90">{description}</div>}
      {action && (
        <button
          onClick={action.onClick}
          className="mt-1 min-h-[32px] rounded border border-slate-300 bg-white px-3 py-1 text-xs font-medium text-slate-700 hover:bg-slate-100"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
